// ============================================================
// MÁQUINA DE PREMIOS · página
// 1. "Sacar mi cápsula" → animación 3D → premio (anillo o collar).
// 2. "Reclamar mi premio" → revisa el carrito: con $20 en productos
// elegibles agrega el regalo a $0; si falta, dice cuánto.
// El sorteo se hace una sola vez por persona y queda guardado.
// ============================================================
import { sonido, alternarSonido, sonidoActivo, confeti, vibrar } from "./coco-maq-efectos.js";

const Q = window.cocoMaquina;
const M = Q.config;
const $ = (s, r = document) => r.querySelector(s);
const CLAVE = "coco-maquina-premio";
const reducido = () => matchMedia("(prefers-reduced-motion: reduce)").matches;
const esc = (t) => String(t ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
const leer = () => { try { return JSON.parse(localStorage.getItem(CLAVE) || "null"); } catch { return null; } };
const guardar = (v) => { try { localStorage.setItem(CLAVE, JSON.stringify(v)); } catch {} };
const premioPorId = (id) => M.premios.find((p) => p.id === id);

const raiz = $("[data-maquina]");
const cta = $("[data-cta]"), ctaTexto = $("[data-cta-texto]");
const dlg = $("[data-modal]"), caja = $(".maq-modal-caja", dlg);
let escena = null, volver = null, imagenes = {};

// ---------- aviso breve ----------
window.cocoMaquinaAviso = (texto, ms = 3200) => {
let a = $(".maq-aviso");
if (!a) { a = document.createElement("div"); a.className = "maq-aviso"; a.setAttribute("role", "status"); document.body.append(a); }
a.textContent = texto;
a.classList.add("ver");
clearTimeout(a._t);
a._t = setTimeout(() => a.classList.remove("ver"), ms);
};

// ---------- botón de sonido ----------
const btnSonido = $("[data-sonido]");
const pintarSonido = () => btnSonido?.setAttribute("aria-pressed", String(sonidoActivo()));
pintarSonido();
btnSonido?.addEventListener("click", () => { alternarSonido(); pintarSonido(); if (sonidoActivo()) sonido.pop(); });

// ---------- barra de progreso del carrito ----------
async function pintarMeta() {
const meta = $("[data-meta]");
if (!meta) return null;
try {
const r = await Q.revisarCarrito();
const pct = Math.min(100, (r.elegibles / r.minimo) * 100);
meta.hidden = false;
meta.style.setProperty("--avance", pct + "%");
$("[data-meta-texto]", meta).innerHTML = r.cumple
? `<b>¡Ya llegaste a ${Q.dinero(r.minimo)}!</b> Tu carrito puede recibir el regalo.`
: r.elegibles > 0
? `Llevas <b>${Q.dinero(r.elegibles)}</b> · te faltan <b>${Q.dinero(r.falta)}</b> para reclamar tu regalo`
: `Con <b>${Q.dinero(r.minimo)}</b> en tu carrito, tu premio va gratis`;
meta.classList.toggle("completo", r.cumple);
return r;
} catch {
meta.hidden = true;
return null;
}
}
document.addEventListener("coco-maquina:carrito", pintarMeta);

// ---------- textos de la página ----------
function prepararTextos() {
const fmt = (d) => new Intl.DateTimeFormat("es-EC", { day: "numeric", month: "short", timeZone: "America/Guayaquil" }).format(d).replace(".", "");
document.querySelectorAll("[data-fechas]").forEach((el) => (el.textContent = `${fmt(Q.inicio()).split(" ")[0]} – ${fmt(Q.fin())}`));
const lc = $("[data-condiciones]");
if (lc) lc.innerHTML = M.condiciones.map((c) => `<li>${esc(c)}</li>`).join("");
const lp = $("[data-premios]");
if (lp) lp.innerHTML = M.premios.map((p) => `<li><img src="${esc(p.imagen)}&width=240" alt="" width="120" height="120" loading="lazy"><b>${esc(p.nombre)}</b><span>Valor ${Q.dinero(p.precio * 100)}</span></li>`).join("");
if (Q.vistaPrevia() || window.COCO_MAQUINA_DEMO) {
const d = $("[data-solo-prueba]");
if (d) d.hidden = false;
$("[data-reiniciar]")?.addEventListener("click", () => { try { localStorage.removeItem(CLAVE); } catch {} location.reload(); });
}
}

// ---------- sorteo (una vez por persona) ----------
async function sortear() {
const prev = leer();
if (prev && premioPorId(prev.id)) return { premio: premioPorId(prev.id), repetido: true };
let disp = [];
try { disp = await Q.disponibilidad(); } catch {}
disp.forEach((d) => (imagenes[d.id] = d.imagen));
const libres = M.premios.filter((p) => (disp.find((d) => d.id === p.id) || { disponible: true }).disponible);
if (!libres.length) return { agotado: true };
const total = libres.reduce((s, p) => s + (+p.probabilidad || 0), 0) || libres.length;
let x = Math.random() * total, elegido = libres[libres.length - 1];
for (const p of libres) { x -= +p.probabilidad || 1; if (x < 0) { elegido = p; break; } }
guardar({ id: elegido.id, fecha: new Date().toISOString() });
return { premio: elegido, repetido: false };
}

// ---------- ventana del premio y sus estados ----------
const cerrarBtn = `<button class="maq-cerrar" type="button" data-cerrar aria-label="Cerrar"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>`;
function abrir(html, { festejar = false } = {}) {
caja.innerHTML = cerrarBtn + html;
$("[data-cerrar]", caja).addEventListener("click", () => dlg.close());
if (!dlg.open) dlg.showModal();
caja.scrollTop = 0;
if (festejar) { sonido.ganar(); vibrar([18, 50, 24]); confeti({ y: 0.3 }); }
}
dlg.addEventListener("click", (e) => { if (e.target === dlg) dlg.close(); });
dlg.addEventListener("close", async () => { if (volver) { const f = volver; volver = null; await f(); } });

const fotoPremio = (p) => esc((imagenes[p.id] || p.imagen) + (/\?/.test(imagenes[p.id] || p.imagen) ? "&" : "?") + "width=600");

// talla elegida (solo premios con tallas, como el anillo); queda guardada con el premio
const tallaGuardada = (p) => { const g = leer(); return g && g.id === p.id && (p.tallas || []).includes(g.talla) ? g.talla : ""; };
const guardarTalla = (p, talla) => { const g = leer(); if (g && g.id === p.id) guardar({ ...g, talla }); };

function mostrarGanado(p, { repetido = false } = {}) {
const tallas = p.tallas || [];
let talla = tallaGuardada(p);
abrir(`
<div class="maq-foto"><img src="${fotoPremio(p)}" alt="${esc(p.nombre)}" width="300" height="300"></div>
<p class="maq-modal-ante">${repetido ? "Tu premio" : "¡Te salió!"}</p>
<h2 class="maq-modal-premio" id="maqTitulo">${esc(p.nombre)}</h2>
<p class="maq-modal-detalle">${esc(p.detalle)} <b>Gratis</b> con ${Q.dinero(M.minimo * 100)} en tu carrito.</p>
${repetido ? `<p class="maq-modal-letra">Ya sacaste tu cápsula: este es el premio que te tocó ♡</p>` : ""}
${tallas.length ? `<fieldset class="maq-tallas">
<legend>Elige la talla de tu anillo</legend>
<div class="maq-tallas-opciones">${tallas.map((t) => `<label><input type="radio" name="maq-talla" value="${esc(t)}"${t === talla ? " checked" : ""}><span>${esc(t)}</span></label>`).join("")}</div>
<a class="maq-tallas-guia" href="/pages/guia-de-talla-de-anillos" target="_blank" rel="noopener">¿No sabes tu talla? Mira la guía</a>
</fieldset>` : ""}
<div class="maq-modal-acciones">
<button class="maq-cta" type="button" data-reclamar${tallas.length && !talla ? " disabled" : ""}>${tallas.length && !talla ? "Elige tu talla" : "Reclamar mi premio"}</button>
</div>`, { festejar: !repetido });
dlg.setAttribute("aria-labelledby", "maqTitulo");
const btn = $("[data-reclamar]", caja);
caja.querySelectorAll("input[name=maq-talla]").forEach((r) => r.addEventListener("change", () => {
talla = r.value;
guardarTalla(p, talla);
sonido.boton();
btn.disabled = false;
btn.textContent = "Reclamar mi premio";
}));
btn.addEventListener("click", (e) => reclamar(p, e.currentTarget, talla ? { talla } : {}));
}

function barra(r) {
const pct = Math.min(100, (r.elegibles / r.minimo) * 100);
return `<div class="maq-barra" style="--avance:${pct}%"><span></span></div>
<p class="maq-barra-texto">${Q.dinero(r.elegibles)} de ${Q.dinero(r.minimo)}</p>`;
}

async function reclamar(p, boton, opciones = {}) {
boton.disabled = true;
boton.textContent = "Revisando tu carrito…";
sonido.boton();
const res = await Q.reclamar(p.id, opciones);
const r = res.r;
if (res.ok) {
abrir(`
<div class="maq-foto maq-foto-chica"><img src="${fotoPremio(p)}" alt="" width="200" height="200"></div>
<p class="maq-modal-ante">¡Listo!</p>
<h2 class="maq-modal-premio" id="maqTitulo">Tu ${esc(p.nombre.toLowerCase())}${opciones.talla ? ` talla ${esc(opciones.talla)}` : ""} ya está en tu carrito</h2>
<p class="maq-modal-detalle">Va a <b>$0</b> en tu pedido. Si tu carrito baja de ${Q.dinero(M.minimo * 100)}, el regalo se retira hasta que vuelvas a llegar.</p>
<div class="maq-modal-acciones">
<a class="maq-cta" href="${(window.Shopify?.routes?.root || "/")}cart">Ir a mi carrito</a>
<a class="maq-secundario" href="${esc(M.seguirComprando)}">Seguir comprando</a>
</div>`, { festejar: !res.yaEstaba });
pintarMeta();
return;
}
if (res.motivo === "falta") {
abrir(`
<div class="maq-foto maq-foto-chica"><img src="${fotoPremio(p)}" alt="" width="200" height="200"></div>
<p class="maq-modal-ante">¡Casi!</p>
<h2 class="maq-modal-premio" id="maqTitulo">Te faltan ${Q.dinero(r.falta)}</h2>
<p class="maq-modal-detalle">Tu ${esc(p.nombre.toLowerCase())} te espera. Necesitas ${Q.dinero(r.minimo)} en productos para reclamarlo${r.elegibles ? "" : ", y tu carrito todavía está vacío"}.</p>
${barra(r)}
<p class="maq-modal-letra">Tu premio queda guardado: vuelve a esta página cuando llegues ♡</p>
<div class="maq-modal-acciones">
<a class="maq-cta" href="${esc(M.seguirComprando)}">Seguir comprando</a>
</div>`);
return;
}
if (res.motivo === "otros-codigos") {
abrir(`
<p class="maq-modal-ante">Un detalle</p>
<h2 class="maq-modal-premio" id="maqTitulo">Tu regalo no se acumula</h2>
<p class="maq-modal-detalle">Tu carrito tiene el código <b>${esc(r.otrosCodigos.join(", "))}</b>. Para que tu ${esc(p.nombre.toLowerCase())} vaya a $0, ese código se quitará.</p>
<div class="maq-modal-acciones">
<button class="maq-cta" type="button" data-si>Sí, quiero mi regalo</button>
<button class="maq-secundario" type="button" data-no>Mantener mi código</button>
</div>`);
$("[data-si]", caja).addEventListener("click", (e) => reclamar(p, e.currentTarget, { ...opciones, reemplazarCodigos: true }));
$("[data-no]", caja).addEventListener("click", () => dlg.close());
return;
}
if (res.motivo === "agotado") {
abrir(`
<p class="maq-modal-ante">¡Ay, no!</p>
<h2 class="maq-modal-premio" id="maqTitulo">Se agotó este premio</h2>
<p class="maq-modal-detalle">Las joyitas de la máquina volaron. Escríbenos y te ayudamos ♡</p>
<div class="maq-modal-acciones"><a class="maq-secundario" href="${esc(M.whatsapp)}" target="_blank" rel="noopener">Escribir por WhatsApp</a></div>`);
return;
}
if (res.motivo === "fuera-de-fecha") {
abrir(`<p class="maq-modal-ante">Uy</p><h2 class="maq-modal-premio" id="maqTitulo">La máquina está cerrada</h2><p class="maq-modal-detalle">Los premios se reclaman del ${esc($("[data-fechas]")?.textContent || "19 al 25 de octubre")}.</p>`);
return;
}
// sin-descuento o error
const enPrueba = Q.vistaPrevia() || window.COCO_MAQUINA_DEMO;
abrir(`
<p class="maq-modal-ante">Uy</p>
<h2 class="maq-modal-premio" id="maqTitulo">No pudimos agregar tu regalo</h2>
<p class="maq-modal-detalle">${enPrueba && res.motivo === "sin-descuento" ? "Vista previa: el descuento de Shopify todavía no está activo (empieza el 19 de octubre) o no hay código de prueba. El regalo se retiró para no cobrarlo." : "Inténtalo otra vez en un momento. Si sigue pasando, escríbenos y lo agregamos por ti ♡"}</p>
<div class="maq-modal-acciones">
<button class="maq-cta" type="button" data-otra>Intentar otra vez</button>
<a class="maq-secundario" href="${esc(M.whatsapp)}" target="_blank" rel="noopener">Escribir por WhatsApp</a>
</div>`);
$("[data-otra]", caja).addEventListener("click", (e) => reclamar(p, e.currentTarget, opciones));
}

// ---------- fuera de fecha ----------
function bloquear(est) {
$("[data-juego]").hidden = true;
const b = $("[data-bloqueo]");
b.hidden = false;
const img = `<img src="${esc(M.premios[0].imagen)}&width=400" alt="" width="200" height="200">`;
if (est === "proximo") {
b.innerHTML = `${img}<h2>Muy pronto</h2><p>La Máquina de premios abre el <b>${esc(new Intl.DateTimeFormat("es-EC", { day: "numeric", month: "long", timeZone: "America/Guayaquil" }).format(Q.inicio()))}</b>. ¡Te esperamos!</p><div class="maq-cuenta" data-cuenta aria-live="polite"></div><a class="maq-secundario" href="${esc(M.seguirComprando)}">Ver la tienda</a>`;
const cuenta = $("[data-cuenta]", b);
const pintar = () => {
const ms = Math.max(0, Q.inicio() - Q.ahora());
const d = Math.floor(ms / 86400000), h = Math.floor((ms % 86400000) / 3600000), m = Math.floor((ms % 3600000) / 60000);
cuenta.innerHTML = `<span>${d}<small>días</small></span><span>${h}<small>horas</small></span><span>${m}<small>min</small></span>`;
};
pintar();
setInterval(pintar, 30000);
} else {
b.innerHTML = `${img}<h2>La máquina ya cerró</h2><p>Estuvo activa del ${esc($("[data-fechas]")?.textContent || "")}. ¡Gracias por jugar!</p><a class="maq-secundario" href="${esc(M.seguirComprando)}">Ver la tienda</a>`;
}
}

// ---------- 3D ----------
async function montar() {
const contenedor = $("[data-escenario]");
try {
const { webglDisponible } = await import("./coco-maq-motor.js");
if (!webglDisponible()) return null;
const { montarMaquina } = await import("./coco-maq-3d.js");
return await montarMaquina(contenedor, { sonido, vibrar, reducido, alTocar: () => cta.click() });
} catch (e) {
console.warn("Máquina sin 3D:", e);
return null;
}
}

// ---------- inicio ----------
async function iniciar() {
prepararTextos();
const est = Q.estado();
pintarMeta();
if (est !== "activo") { bloquear(est); return; }
cta.disabled = true;
ctaTexto.textContent = "Preparando la máquina…";
escena = await montar();
if (!escena) raiz.classList.add("sin-3d");
const previo = leer();
cta.disabled = false;
// En la vista de prueba se puede jugar las veces que quieras
const prueba = Q.vistaPrevia() || window.COCO_MAQUINA_DEMO;
if (previo && premioPorId(previo.id) && !prueba) {
ctaTexto.textContent = "Ver mi premio";
cta.onclick = () => mostrarGanado(premioPorId(previo.id), { repetido: true });
return;
}
ctaTexto.textContent = "Sacar mi cápsula";
$("[data-pista3d]").hidden = !escena;
cta.onclick = async () => {
cta.disabled = true;
if (prueba) { try { localStorage.removeItem(CLAVE); } catch {} }
vibrar(10);
$("[data-pista3d]").hidden = true;
const s = await sortear();
if (s.agotado) {
cta.disabled = false;
abrir(`<p class="maq-modal-ante">¡Ay, no!</p><h2 class="maq-modal-premio">Se acabaron las cápsulas</h2><p class="maq-modal-detalle">Los premios de la máquina se agotaron. ¡Gracias por jugar con nosotras!</p>`);
return;
}
if (escena) volver = await escena.sacar(s.premio);
else { raiz.classList.add("agitando"); sonido.boton(); await new Promise((r) => setTimeout(r, 900)); raiz.classList.remove("agitando"); }
mostrarGanado(s.premio, { repetido: s.repetido });
cta.disabled = false;
if (prueba) { ctaTexto.textContent = "Jugar otra vez (prueba)"; return; }
ctaTexto.textContent = "Ver mi premio";
cta.onclick = () => mostrarGanado(s.premio, { repetido: true });
};
}
iniciar();